export var NOTIFICATION_EVENT;
(function (NOTIFICATION_EVENT) {
    NOTIFICATION_EVENT["BOOKING_CREATED"] = "BOOKING_CREATED";
    NOTIFICATION_EVENT["BOOKING_STATUS_UPDATED"] = "BOOKING_STATUS_UPDATED";
    NOTIFICATION_EVENT["BOOKING_DOCUMENT_CREATED"] = "BOOKING_DOCUMENT_CREATED";
    NOTIFICATION_EVENT["BOOKING_DOCUMENT_UPDATED"] = "BOOKING_DOCUMENT_UPDATED";
    NOTIFICATION_EVENT["RESPONDENT_DOCUMENT_CREATED"] = "RESPONDENT_DOCUMENT_CREATED";
    NOTIFICATION_EVENT["RESPONDENT_DOCUMENT_UPDATED"] = "RESPONDENT_DOCUMENT_UPDATED";
    NOTIFICATION_EVENT["RESPONDENT_NOTE_CREATED"] = "RESPONDENT_NOTE_CREATED";
    NOTIFICATION_EVENT["RESPONDENT_NOTE_UPDATED"] = "RESPONDENT_NOTE_UPDATED";
    NOTIFICATION_EVENT["SURVEY_CREATED"] = "SURVEY_CREATED";
    NOTIFICATION_EVENT["SURVEY_STATUS_UPDATED"] = "SURVEY_STATUS_UPDATED";
    NOTIFICATION_EVENT["CASE_CREATED"] = "CASE_CREATED";
    NOTIFICATION_EVENT["CASE_UPDATED"] = "CASE_UPDATED";
    NOTIFICATION_EVENT["CASE_CLOSED"] = "CASE_CLOSED";
    NOTIFICATION_EVENT["CASE_REOPENED"] = "CASE_REOPENED";
    NOTIFICATION_EVENT["AI_SURVEY_GENERATION_COMPLETE"] = "AI_SURVEY_GENERATION_COMPLETE";
})(NOTIFICATION_EVENT || (NOTIFICATION_EVENT = {}));
export const NOTIFICATION_EVENT_OPTIONS = {
    [NOTIFICATION_EVENT.BOOKING_CREATED]: {
        id: NOTIFICATION_EVENT.BOOKING_CREATED,
        label: "Booking Created",
    },
    [NOTIFICATION_EVENT.BOOKING_STATUS_UPDATED]: {
        id: NOTIFICATION_EVENT.BOOKING_STATUS_UPDATED,
        label: "Booking Status Updated",
    },
    [NOTIFICATION_EVENT.BOOKING_DOCUMENT_CREATED]: {
        id: NOTIFICATION_EVENT.BOOKING_DOCUMENT_CREATED,
        label: "Booking Document Created",
    },
    [NOTIFICATION_EVENT.BOOKING_DOCUMENT_UPDATED]: {
        id: NOTIFICATION_EVENT.BOOKING_DOCUMENT_UPDATED,
        label: "Booking Document Updated",
    },
    [NOTIFICATION_EVENT.RESPONDENT_DOCUMENT_CREATED]: {
        id: NOTIFICATION_EVENT.RESPONDENT_DOCUMENT_CREATED,
        label: "Respondent Document Created",
    },
    [NOTIFICATION_EVENT.RESPONDENT_DOCUMENT_UPDATED]: {
        id: NOTIFICATION_EVENT.RESPONDENT_DOCUMENT_UPDATED,
        label: "Respondent Document Updated",
    },
    [NOTIFICATION_EVENT.RESPONDENT_NOTE_CREATED]: {
        id: NOTIFICATION_EVENT.RESPONDENT_NOTE_CREATED,
        label: "Respondent Note Created",
    },
    [NOTIFICATION_EVENT.RESPONDENT_NOTE_UPDATED]: {
        id: NOTIFICATION_EVENT.RESPONDENT_NOTE_UPDATED,
        label: "Respondent Note Updated",
    },
    [NOTIFICATION_EVENT.SURVEY_CREATED]: {
        id: NOTIFICATION_EVENT.SURVEY_CREATED,
        label: "Survey Created",
    },
    [NOTIFICATION_EVENT.SURVEY_STATUS_UPDATED]: {
        id: NOTIFICATION_EVENT.SURVEY_STATUS_UPDATED,
        label: "Survey Status Updated",
    },
    [NOTIFICATION_EVENT.AI_SURVEY_GENERATION_COMPLETE]: {
        id: NOTIFICATION_EVENT.AI_SURVEY_GENERATION_COMPLETE,
        label: "AI Survey Generation Complete",
        defaultEnabled: true,
        subscribable: false,
        featureFlag: "aiFeatures",
    },
    [NOTIFICATION_EVENT.CASE_CREATED]: {
        id: NOTIFICATION_EVENT.CASE_CREATED,
        label: "Case Created",
    },
    [NOTIFICATION_EVENT.CASE_UPDATED]: {
        id: NOTIFICATION_EVENT.CASE_UPDATED,
        label: "Case Updated",
    },
    [NOTIFICATION_EVENT.CASE_CLOSED]: {
        id: NOTIFICATION_EVENT.CASE_CLOSED,
        label: "Case Closed",
    },
    [NOTIFICATION_EVENT.CASE_REOPENED]: {
        id: NOTIFICATION_EVENT.CASE_REOPENED,
        label: "Case Reopened",
    }
};
//# sourceMappingURL=notification.js.map